<template>
    <Drawer v-model:visible="visible" :header="$t('notification.title')" position="right" id="EasyNotificationsDrawer">
        <ul class="list-none p-0 m-0">
            <li class="px-4 py-1 mb-3" v-for="notification in notifications" :key="notification.id"
                :class="notification.unread ? 'unread' : ''" @click="readNotification(notification.id)">
                <div class="flex items-center">
                    <img :src="$utils.getAvatar(notification.avatar)" class="notification-avatar">
                    <div class="flex flex-col ml-4 flex-1">
                        <div class="flex items-center justify-between mb-1"><span class="font-bold">{{
        notification.nickname }}</span>
                            <small>
                                {{ calculateTimeAgo(notification.created_at) }}
                            </small>
                        </div><span class="text-sm leading-normal"
                            v-html="$t('notification.giftReceived', { gold: notification.used_gold, image: getImageUrl(notification.data) })"></span>
                    </div>
                </div>
            </li>
        </ul>
        <template #footer>
            <div class="flex items-center gap-2">
                <Button :label="$t('notification.clear_all')" icon="pi pi-trash" class="flex-auto" severity="warn" plain text
                    @click="clearNotifications()"></Button>
                <Button :label="$t('notification.read_all')" class="flex-auto" plain text @click="readAll()"></Button>
            </div>
        </template>
    </Drawer>
</template>

<script>
export default {
    name: "Notifications",
    props: ['notifications'],
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        toogleNotifications() {
            this.visible = !this.visible
        },
        calculateTimeAgo(created_at) {
            const postDate = new Date(created_at);
            const currentDate = new Date();

            const diffInMs = currentDate - postDate;

            const diffInSeconds = Math.floor(diffInMs / 1000);
            const diffInMinutes = Math.floor(diffInSeconds / 60);
            const diffInHours = Math.floor(diffInMinutes / 60);
            const diffInDays = Math.floor(diffInHours / 24);

            if (diffInDays > 7) {
                return postDate.toLocaleDateString();
            } else if (diffInSeconds < 60) {
                return `${diffInSeconds}` + this.$t('times.seconds_ago');
            } else if (diffInMinutes < 60) {
                return `${diffInMinutes}` + this.$t('times.minutes_ago')
            } else if (diffInHours < 24) {
                return `${diffInHours} ` + this.$t('times.hours_ago')
            } else {
                return `${diffInDays} ` + this.$t('times.days_ago')
            }
        },
        readAll() {
            this.$socket.emit('readAllNotifications');
            this.$emit('notificationAction', { action: 'read', id: 'all' });
        },
        readNotification(id) {
            this.$socket.emit('readNotification', id);
            this.$emit('notificationAction', { action: 'read', id: id });
        },
        clearNotifications() {
            this.$socket.emit('clearNotifications');
            this.$emit('notificationAction', { action: 'delete', id: 'all' });
        },
        getImageUrl(data) {
            try {
                const gift = JSON.parse(data);
                console.log(gift);
                if (gift) {
                    return gift.image
                }
            } catch (error) {
                return '';
            }


        }
    },
}

</script>


<style scoped>
.notification-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

.justify-between {
    justify-content: space-between;
}

.items-center {
    align-items: center;
}

.unread {
    background-color: var(--p-neutral-100);
    cursor: pointer;
}


</style>